var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAwaitingValidation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 66 66",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m21.2 23.3h-5.7c-.6 0-1 .4-1 1v6.4c0 .6.4 1 1 1h5.7c.6 0 1-.4 1-1v-6.4c0-.6-.4-1-1-1zm-1 6.4h-3.7v-4.4h3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.9 28.9c-.6 0-1 .4-1 1s.4 1 1 1h15.7c.6 0 1-.4 1-1s-.4-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.2 36.5h-5.7c-.6 0-1 .4-1 1v6.4c0 .6.4 1 1 1h5.7c.6 0 1-.4 1-1v-6.4c0-.6-.4-1-1-1zm-1 6.3h-3.7v-4.4h3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.6 37.3h-15.7c-.6 0-1 .4-1 1s.4 1 1 1h15.7c.6 0 1-.4 1-1s-.4-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.6 42h-15.7c-.6 0-1 .4-1 1s.4 1 1 1h15.7c.6 0 1-.4 1-1 0-.5-.4-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.2 49.6h-5.7c-.6 0-1 .4-1 1v6.4c0 .6.4 1 1 1h5.7c.6 0 1-.4 1-1v-6.4c0-.5-.4-1-1-1zm-1 6.4h-3.7v-4.4h3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.6 50.4h-15.7c-.6 0-1 .4-1 1s.4 1 1 1h15.7c.6 0 1-.4 1-1 0-.5-.4-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.6 55.2h-15.7c-.6 0-1 .4-1 1s.4 1 1 1h15.7c.6 0 1-.4 1-1s-.4-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.8 1.6c-2.1 0-4.1.5-5.9 1.4h-36.1c-1.9 0-3.4 1.5-3.4 3.4v54.5c0 1.9 1.5 3.4 3.5 3.4h38.3c1.9 0 3.4-1.5 3.4-3.4v-31.7h.3c7.6 0 13.8-6.2 13.8-13.8-.1-7.6-6.3-13.8-13.9-13.8zm-2.3 59.3c0 .8-.7 1.4-1.4 1.4h-38.3c-.8 0-1.5-.7-1.5-1.4v-54.5c.1-.8.7-1.4 1.5-1.4h33c-2.9 2.5-4.8 6.3-4.8 10.4 0 3.3 1.2 6.3 3.1 8.7h-12.2c-.6 0-1 .4-1 1s.4 1 1 1h14.2c1.8 1.5 4 2.5 6.4 2.9zm2.3-33.7c-6.5 0-11.8-5.3-11.8-11.8s5.3-11.8 11.8-11.8 11.8 5.3 11.8 11.8-5.3 11.8-11.8 11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.8 20.7h-8.9v-10.6h8.9c.6 0 1-.4 1-1s-.4-1-1-1h-9.9c-.6 0-1 .4-1 1v12.5c0 .6.4 1 1 1h9.9c.6 0 1-.4 1-1 0-.5-.4-.9-1-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.5 12.2-3.9 3.9-1.4-1.4c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l2.1 2.1c.4.4 1 .4 1.4 0l4.6-4.6c.4-.4.4-1 0-1.4-.4-.3-1-.3-1.4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.9 20.3v-1.6c0-2.3-1.2-4.2-3.1-5.2.9-.8 1.5-1.9 1.5-3.2 0-2.3-2-4.2-4.5-4.2s-4.5 1.9-4.5 4.2c0 1.3.6 2.4 1.5 3.2-1.8 1-3.1 3-3.1 5.2v1.6c0 .6.4 1 1 1h10c.8 0 1.2-.5 1.2-1zm-6-12.3c1.4 0 2.5 1 2.5 2.2s-1.1 2.2-2.5 2.2-2.5-1-2.5-2.2 1.1-2.2 2.5-2.2zm4 11.3h-8v-.6c0-2.2 1.8-4 4-4s4 1.8 4 4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwaitingValidation);
export default __webpack_public_path__ + "static/media/awaiting-validation.3598e787bc9a606dbba10b980123b5da.svg";
export { ForwardRef as ReactComponent };